import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useAuthStatus } from 'src/provider/auth';

export const useAuthStatePageReload = (
  isInitialReload: boolean,
  callAuthState: boolean,
) => {
  const { authStatus } = useAuthStatus();
  const currentAuthState = authStatus === 'authenticated';
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitialReload && callAuthState !== currentAuthState) {
      navigate(location.pathname + location.search, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callAuthState, currentAuthState]);
};
